import React from 'react'
import { Feed } from '../features'

const Home = () => {
    return (
        <div className="container mx-auto min-h-screen bg-pink-50">
            <Feed />
        </div>
    )
}

export default Home